<template>
  <validation-observer ref="updateSystemRateRef" #default="{ valid }">
    <b-modal
      ref="modal"
      title="Cập nhật tỉ giá chung"
      centered
      cancel-variant="outline-secondary"
      @ok.prevent="handleApply"
      :ok-disabled="loading || !valid"
      @cancel="resetForm"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group label="Tỉ giá chung (¥ → đ)" label-for="systemExchangeRate">
            <validation-provider
              #default="{ errors }"
              name="systemExchangeRate"
              vid="systemExchangeRate"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  v-currency="config"
                  v-model="exchangeRate"
                  name="systemExchangeRate"
                  :placeholder="placeholderText"
                />
                <b-input-group-append is-text>đ</b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{
                errors[0] && "Tỉ giá không hợp lệ."
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-cancel>
        <span>Hủy</span>
      </template>
      <template #modal-ok>
        <Spinner v-if="loading" />
        <span v-else>Áp dụng</span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { ExchangeRateEnum } from "@/@core/utils/enums/exchange-rate.enum";
import useToastHandler from "@/services/toastHandler";
import Spinner from "@core/components/Spinner";
import {
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  BRow,
  VBModal,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    BRow,
    Spinner,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      exchangeRate: null,
      currentRate: null,
    };
  },
  computed: {
    ...mapState({
      loading: (s) => s.apps.systemExchangeRate.loading,
    }),
    config() {
      return {
        currency: null,
        precision: { min: 0, max: 2 },
      };
    },
    placeholderText() {
      if (this.currentRate > 0) {
        return `Tỉ giá hiện tại: ${Number(this.currentRate).toLocaleString(
          "vi-VN"
        )}`;
      }
      return "Nhập tỉ giá, vd: 3650";
    },
  },
  methods: {
    ...mapActions({
      getSystemRate: "systemExchangeRate/getSystemExchangeRate",
      updateSystemRate: "systemExchangeRate/updateSystemExchangeRate",
    }),
    async handleShowModal() {
      this.$refs.modal.show();
      await this.loadCurrent();
    },
    async loadCurrent() {
      this.currentRate = null;
      const res = await this.getSystemRate();
      if (res && res.exchangeRate > 0) {
        this.currentRate = res.exchangeRate;
      }
    },
    async handleApply() {
      const exchangeRate = Number(
        this.$parseCurrency(this.exchangeRate, {
          locale: "en",
          currency: null,
        })
      );
      const res = await this.updateSystemRate({
        exchangeRate,
        exchangeRateType: ExchangeRateEnum.CNY_TO_VND,
      });
      if (!res) return;

      this.showToastSuccess(null, "Cập nhật tỉ giá chung thành công.");
      this.resetForm();
    },
    resetForm() {
      this.exchangeRate = null;
      this.$refs.updateSystemRateRef.reset();
      this.$refs.modal.hide();
    },
  },
  setup() {
    return {
      ...useToastHandler(),
    };
  },
};
</script>
